import { useContext, useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Badge, Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import logo from "../assets/images/logo-one.png";
import "../assets/css/sidebar.css";
import { themeColors } from "../constant/ThemeColor";
import { AuthContext } from "../context/authContext";
import { startPoint } from "../constant/ThemeFonts";
import useDeviceType from "./useWindowSize";
import { LoadingContext } from "../context/loadingProviderContext";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const navigate = useNavigate();
  const isActive = selected === title;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const menuItemStyle = {
    position: "relative",
    padding: "18px 5px",
    cursor: "pointer",
  };

  const badgeStyle = {
    position: "absolute",
    top: "-25px",
    right: "-15px",
    marginRight: "8px",
    backgroundColor: "#d7f62f",
    width: "25px",
    height: "25px",
    borderRadius: "50%",
  };

  return (
    <MenuItem
      active={isActive}
      className={`slider-menu ${isActive ? "slider-active-menu" : ""}`}
      onClick={() => {
        setSelected(title);
        navigate(`${to}`);
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      icon={icon}
      style={menuItemStyle}
    >
      <Box display="flex" alignItems="center">
        <span
          style={{ marginRight: "18px", fontSize: "12px", fontWeight: "500" }}
        >
          {title}
        </span>
        {title === "Workflows" && (
          <Badge
            className="workflow-error"
            color="error"
            overlap="circular"
            style={{ ...badgeStyle }}
          ></Badge>
        )}
      </Box>
    </MenuItem>
  );
};

const Sidebar = () => {
  const { deviceType } = useDeviceType();
  console.log("deviceType", deviceType);
  const [isCollapsed, setIsCollapsed] = useState(
    deviceType !== "xs" ? false : true
  );
  const [selected, setSelected] = useState("Overview");
  const { loading } = useContext(LoadingContext);
  const { user } = useContext(AuthContext);
  console.log("user NUKOLAS", user);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box
      // className="main-div-box"
      className={`main-div-box ${loading ? "blur" : ""}`}
      component={"div"}
      sx={{
        "& ..css-1l8icbj": {
          padding: "0%",
        },
        "& .pro-sidebar-inner": {
          // background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item :hover": {
          color: `${themeColors.white} !important`,
        },
        "& .pro-menu-item.active": {
          color: `${themeColors.white} !important`,
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed} className="custom-sliderBar">
        <Menu iconShape="square">
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={
              isCollapsed ? (
                <img src={logo} alt="e-logo" className="logo" />
              ) : undefined
            }
            style={{
              margin: "10px 0 20px 0",
            }}
            setIsCollapsed
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3">
                  <img
                    src={`https://cdn.shopify.com/s/files/1/0629/0512/2974/files/logo-one.png?v=1701175868`}
                    alt="e-logo"
                    className="logo"
                  />
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  {/* <MenuOutlinedIcon /> */}
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                {/* User Image or Logo Image if needs */}
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                ></Typography>
              </Box>
            </Box>
          )}
          <Box
            component={"div"}
            sx={{ display: "contents" }}
            // sx={{ display: isCollapsed ? "none" : "block" }}
          >
            <Box
              paddingLeft={isCollapsed ? undefined : "10%"}
              sx={{ display: "contents" }}
            >
              <Item
                className="item-hover"
                title="Overview"
                to={`${startPoint}/`}
                icon={
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 13 13"
                    enable-background="new 0 0 13 13"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.9,5.2L6.8,0.1h0C6.7,0,6.6,0,6.5,0C6.4,0,6.3,0,6.2,0.1l-6,6  C0,6.3,0,6.5,0,6.6c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.3,0,0.4-0.1l0.1-0.1v5.8c0,0.1,0,0.2,0.1,0.3C1.1,13,1.3,13,1.4,13h10.2  c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3l0-5.8l0.1,0.1v0c0.1,0.1,0.3,0.2,0.4,0.1c0.2,0,0.3-0.2,0.3-0.3c0-0.2,0-0.3-0.1-0.4  L11.9,5.2z M5.1,12.1V8.4h2.8v3.7H5.1z M8.8,12.1h2.3V5.8L6.5,1.1L1.9,5.8v6.3h2.3V7.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1  h3.7c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3V12.1z"
                    />
                  </svg>
                }
                selected={selected}
                setSelected={setSelected}
              />
            </Box>

            <Box
              paddingLeft={isCollapsed ? undefined : "10%"}
              sx={{ display: "contents" }}
            >
              <Item
                title="Purchases"
                to={`${startPoint}/purchases`}
                icon={
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 21 13"
                    enable-background="new 0 0 21 13"
                  >
                    <g>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0,0.5C0,0.2,0.2,0,0.5,0l18.8,0c0.2,0,0.5,0.2,0.5,0.4   c0,0.2-0.2,0.5-0.5,0.4H0.9v9.9c0,0.2-0.2,0.5-0.4,0.5C0.2,11.2,0,11,0,10.8V0.5z M1.8,2.2C1.8,2,2,1.8,2.3,1.8h17.9   c0.2,0,0.4,0.2,0.4,0.4v9.9c0,0.2-0.2,0.4-0.4,0.4H2.3c-0.2,0-0.4-0.2-0.4-0.4V2.2z M2.7,2.7h5.1C6.6,3.8,5.8,5.4,5.8,7.2   c0,1.8,0.8,3.4,1.9,4.5H2.7V2.7z M13.1,2.7H9.3C7.8,3.5,6.7,5.2,6.7,7.2c0,2,1.1,3.7,2.6,4.5h3.7c1.5-0.8,2.6-2.5,2.6-4.5   C15.7,5.2,14.6,3.5,13.1,2.7z M14.7,2.7h5.1v9h-5.1c1.2-1.1,1.9-2.7,1.9-4.5C16.6,5.4,15.8,3.8,14.7,2.7z M10.8,3.8   c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v0.3c0.6,0.2,1.1,0.6,1.3,1.1c0.1,0.2,0,0.5-0.2,0.6c-0.2,0.1-0.5,0-0.6-0.2   c-0.1-0.2-0.3-0.4-0.5-0.5v1.8c0.2,0.1,0.5,0.2,0.7,0.4C12.7,7.5,13,8,13,8.5c0,0.9-0.6,1.5-1.3,1.7v0.3c0,0.2-0.2,0.4-0.4,0.4   c-0.2,0-0.4-0.2-0.4-0.4v-0.3c-0.6-0.2-1.1-0.6-1.3-1.1C9.3,9,9.4,8.6,9.7,8.5c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0.3,0.4,0.5,0.5V7.5   l0,0c-0.2-0.1-0.5-0.2-0.7-0.4C9.7,6.8,9.4,6.4,9.4,5.8c0-0.9,0.6-1.5,1.3-1.7V3.8z M10.8,5v1.4c-0.3-0.1-0.4-0.4-0.4-0.6   C10.3,5.4,10.5,5.2,10.8,5z M12.1,8.5c0-0.3-0.1-0.5-0.4-0.7v1.5C11.9,9.2,12.1,8.9,12.1,8.5z"
                      />
                    </g>
                  </svg>
                }
                selected={selected}
                setSelected={setSelected}
              />
            </Box>

            {user?.user_role !== "Viewer" && (
              <>
                <Box
                  paddingLeft={isCollapsed ? undefined : "10%"}
                  sx={{ display: "contents" }}
                >
                  <Item
                    title="Members"
                    to={`${startPoint}/members`}
                    icon={
                      <svg
                        x="0px"
                        y="0px"
                        viewBox="0 0 16 14"
                        enable-background="new 0 0 16 14"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.2,0C3.5,0,2.1,1.4,2.1,3.1c0,1.7,1.4,3.1,3.1,3.1   s3.1-1.4,3.1-3.1C8.3,1.4,6.9,0,5.2,0z M5.2,0.7c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4S2.8,4.5,2.8,3.1   C2.8,1.8,3.9,0.7,5.2,0.7z"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.2,2.8c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4   s2.4-1.1,2.4-2.4S13.5,2.8,12.2,2.8z M12.2,3.5c1,0,1.7,0.8,1.7,1.7S13.1,7,12.2,7s-1.7-0.8-1.7-1.7S11.2,3.5,12.2,3.5z"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15,13.2c-1.3,0-12.1,0-13.9,0c-0.6,0-1-0.5-1-1v-2.1   C0,8.4,1.4,7,3.1,7C4.4,7,6,7,7.3,7C8.4,7,9.4,7.6,10,8.5c0.3-0.1,0.5-0.1,0.8-0.1c0.9,0,1.9,0,2.8,0c0.6,0,1.3,0.3,1.7,0.7   c0.5,0.5,0.7,1.1,0.7,1.7v1.4c0,0.3-0.1,0.5-0.3,0.7C15.5,13.1,15.2,13.2,15,13.2z M10.4,12.5H15c0.1,0,0.2,0,0.2-0.1   c0.1-0.1,0.1-0.2,0.1-0.2v-1.4c0-0.5-0.2-0.9-0.5-1.2C14.5,9.2,14,9,13.6,9c-0.9,0-1.9,0-2.8,0c-0.2,0-0.3,0-0.5,0.1   c0.1,0.3,0.2,0.6,0.2,1v2.1C10.4,12.3,10.4,12.4,10.4,12.5z M9.7,10.1v2.1c0,0.2-0.2,0.3-0.3,0.3H1c-0.2,0-0.3-0.2-0.3-0.3v-2.1   c0-1.3,1.1-2.4,2.4-2.4h4.2C8.6,7.7,9.7,8.7,9.7,10.1z"
                          />
                        </g>
                      </svg>
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Box>
                {/* Main WorkFlow */}
                <Box
                  paddingLeft={isCollapsed ? undefined : "10%"}
                  sx={{ display: "contents" }}
                >
                  <Item
                    title="Workflows"
                    to={`${startPoint}/workflows`}
                    icon={
                      <svg
                        x="0px"
                        y="0px"
                        viewBox="0 0 16 20"
                        enable-background="new 0 0 16 20"
                      >
                        <g>
                          <path d="M12.5,1h-9C2.8,1,2.2,1.3,1.7,1.7S1,2.8,1,3.5v9c0,0.7,0.3,1.3,0.7,1.8C2.2,14.7,2.8,15,3.5,15h9   c0.7,0,1.3-0.3,1.8-0.7c0.5-0.5,0.7-1.1,0.7-1.8v-9c0-0.7-0.3-1.3-0.7-1.8C13.8,1.3,13.2,1,12.5,1z M14,12.5c0,0.4-0.2,0.8-0.4,1.1   c-0.3,0.3-0.7,0.4-1.1,0.4h-9c-0.4,0-0.8-0.2-1.1-0.4C2.2,13.3,2,12.9,2,12.5v-9c0-0.4,0.2-0.8,0.4-1.1S3.1,2,3.5,2h4v6.6L6.4,7.2   C6.3,7.1,6.2,7,6.1,7C5.9,7,5.8,7,5.7,7.1c-0.1,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2   l1.6,2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1C8.6,10,8.7,9.9,8.8,9.8l1.6-2c0-0.1,0.1-0.1,0.1-0.2   s0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1C10.1,7,10,7,9.9,7C9.9,7,9.8,7,9.8,7.1   c-0.1,0-0.1,0.1-0.1,0.1L8.5,8.6V2h4c0.4,0,0.8,0.2,1.1,0.4C13.8,2.7,14,3.1,14,3.5V12.5z" />
                        </g>
                      </svg>
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Box>
              </>
            )}

            {user?.user_role == "Viewer" && (
              <Box
                paddingLeft={isCollapsed ? undefined : "10%"}
                sx={{ display: "contents" }}
              >
                <Item
                  title="Workflows"
                  to={`${startPoint}/viewerworkflows`}
                  icon={
                    <svg
                      x="0px"
                      y="0px"
                      viewBox="0 0 16 20"
                      enable-background="new 0 0 16 20"
                    >
                      <g>
                        <path d="M12.5,1h-9C2.8,1,2.2,1.3,1.7,1.7S1,2.8,1,3.5v9c0,0.7,0.3,1.3,0.7,1.8C2.2,14.7,2.8,15,3.5,15h9   c0.7,0,1.3-0.3,1.8-0.7c0.5-0.5,0.7-1.1,0.7-1.8v-9c0-0.7-0.3-1.3-0.7-1.8C13.8,1.3,13.2,1,12.5,1z M14,12.5c0,0.4-0.2,0.8-0.4,1.1   c-0.3,0.3-0.7,0.4-1.1,0.4h-9c-0.4,0-0.8-0.2-1.1-0.4C2.2,13.3,2,12.9,2,12.5v-9c0-0.4,0.2-0.8,0.4-1.1S3.1,2,3.5,2h4v6.6L6.4,7.2   C6.3,7.1,6.2,7,6.1,7C5.9,7,5.8,7,5.7,7.1c-0.1,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2   l1.6,2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1C8.6,10,8.7,9.9,8.8,9.8l1.6-2c0-0.1,0.1-0.1,0.1-0.2   s0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1C10.1,7,10,7,9.9,7C9.9,7,9.8,7,9.8,7.1   c-0.1,0-0.1,0.1-0.1,0.1L8.5,8.6V2h4c0.4,0,0.8,0.2,1.1,0.4C13.8,2.7,14,3.1,14,3.5V12.5z" />
                      </g>
                    </svg>
                  }
                  selected={selected}
                  setSelected={setSelected}
                />
              </Box>
            )}

            <Box
              paddingLeft={isCollapsed ? undefined : "10%"}
              sx={{ display: "contents" }}
            >
              <Item
                title="Quotes"
                to={`${startPoint}/quotes`}
                icon={
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 11 14"
                    enable-background="new 0 0 11 14"
                  >
                    <path
                      opacity="0.4996"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      enable-background="new    "
                      d="M0.4,0h9.5  c0.2,0,0.4,0.2,0.4,0.4l0,13.2c0,0.2-0.2,0.4-0.4,0.4H0.4C0.2,14,0,13.8,0,13.6V0.4C0,0.2,0.2,0,0.4,0z M0.8,13.2h8.7V0.8H0.8V13.2z  "
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M8.3,5.5H4.6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4  h3.7c0.2,0,0.4-0.2,0.4-0.4C8.7,5.7,8.6,5.5,8.3,5.5L8.3,5.5z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M2,6.3h1.3c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H2  c-0.2,0-0.4,0.2-0.4,0.4C1.6,6.1,1.8,6.3,2,6.3z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M8.3,9.8H4.6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4  h3.7c0.2,0,0.4-0.2,0.4-0.4C8.7,9.9,8.6,9.8,8.3,9.8z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M2,10.5h1.3c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H2  c-0.2,0-0.4,0.2-0.4,0.4C1.6,10.4,1.8,10.5,2,10.5z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M2,8.4h3.7c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H2  C1.8,7.6,1.6,7.8,1.6,8C1.6,8.3,1.8,8.4,2,8.4z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M8.3,7.6H7C6.8,7.6,6.6,7.8,6.6,8c0,0.2,0.2,0.4,0.4,0.4h1.3  c0.2,0,0.4-0.2,0.4-0.4C8.7,7.8,8.6,7.6,8.3,7.6z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M2,4.2h3.7c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4  L2,3.4c-0.2,0-0.4,0.2-0.4,0.4C1.6,4,1.8,4.2,2,4.2L2,4.2z"
                    />
                    <path
                      opacity="0.4996"
                      enable-background="new    "
                      d="M7,4.2h1.3c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H7  c-0.2,0-0.4,0.2-0.4,0.4S6.8,4.2,7,4.2z"
                    />
                  </svg>
                }
                selected={selected}
                setSelected={setSelected}
              />
            </Box>
            <Box
              paddingLeft={isCollapsed ? undefined : "10%"}
              sx={{ display: "contents" }}
            >
              <Item
                title="Settings"
                to={`${startPoint}/settings`}
                icon={
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 14 14"
                    enable-background="new 0 0 14 14"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.5,13.4h0.4h0c0.7,0,1.2-0.5,1.4-1.1l0,0c0-0.1,0.1-0.2,0.2-0.2  C8.8,12,9,11.9,9.2,11.8c0.1-0.1,0.2,0,0.3,0l0,0c0.2,0.1,0.5,0.2,0.8,0.2c0.4,0,0.7-0.1,1-0.4l0.3-0.3c0.5-0.5,0.5-1.2,0.2-1.7l0,0  c-0.1-0.1-0.1-0.2,0-0.3C11.9,9,12,8.8,12.1,8.5c0-0.1,0.1-0.2,0.2-0.2l0,0c0.6-0.1,1.1-0.7,1.1-1.4V6.5c0-0.7-0.5-1.2-1.1-1.4l0,0  c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.1,0-0.2,0-0.3l0,0c0.4-0.5,0.3-1.3-0.2-1.7l-0.3-0.3  c-0.5-0.5-1.2-0.5-1.8-0.2c-0.1,0.1-0.2,0.1-0.3,0C9,1.5,8.8,1.4,8.5,1.4c-0.1,0-0.2-0.1-0.2-0.3C8.1,0.5,7.6,0,6.9,0H6.5  C5.9,0,5.3,0.5,5.2,1.1c0,0.1-0.1,0.2-0.2,0.2C4.7,1.4,4.4,1.5,4.2,1.7C4.1,1.7,4,1.7,3.9,1.6C3.6,1.5,3.4,1.4,3.1,1.4  c-0.4,0-0.7,0.1-1,0.4L1.8,2.1C1.4,2.6,1.3,3.3,1.6,3.9l0,0c0.1,0.1,0.1,0.2,0,0.3C1.5,4.4,1.4,4.7,1.3,4.9c0,0.1-0.1,0.2-0.2,0.2  C0.5,5.3,0,5.9,0,6.5v0.4c0,0.7,0.5,1.2,1.1,1.4c0.1,0,0.2,0.1,0.2,0.2C1.4,8.8,1.5,9,1.7,9.3c0.1,0.1,0.1,0.2,0,0.3  c-0.4,0.5-0.3,1.3,0.2,1.7l0.3,0.3c0.5,0.5,1.2,0.5,1.8,0.2c0.1-0.1,0.2-0.1,0.3,0c0.2,0.1,0.5,0.2,0.7,0.3c0.1,0,0.2,0.1,0.2,0.3  C5.3,13,5.9,13.4,6.5,13.4z M4.7,10.8c-0.2-0.1-0.4-0.2-0.6-0.2h0c-0.3,0-0.5,0.1-0.8,0.2C3.1,11,3,11,2.9,10.9l-0.3-0.3  c-0.1-0.1-0.1-0.3,0-0.4c0.3-0.4,0.3-0.9,0.1-1.4C2.5,8.6,2.4,8.4,2.4,8.2c-0.2-0.5-0.6-0.8-1-0.9c-0.1,0-0.3-0.2-0.3-0.3V6.5  c0-0.1,0.1-0.3,0.3-0.3c0.5-0.1,0.9-0.5,1-0.9c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.4,0.2-1-0.1-1.4l0,0C2.5,3.1,2.5,3,2.6,2.9l0.3-0.3  c0.1-0.1,0.3-0.1,0.4,0c0.4,0.3,1,0.3,1.4,0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.5-0.2,0.8-0.6,0.9-1c0-0.1,0.2-0.3,0.3-0.3h0.4  c0.1,0,0.3,0.1,0.3,0.3c0.1,0.5,0.5,0.9,0.9,1c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0.2,1,0.2,1.4-0.1c0.1-0.1,0.3-0.1,0.4,0l0.3,0.3  C11,3,11,3.1,10.9,3.3l0,0c-0.3,0.4-0.3,0.9-0.1,1.4C10.9,4.9,11,5.1,11,5.3c0.2,0.5,0.6,0.8,1,0.9l0,0c0.1,0,0.3,0.2,0.3,0.3v0.4  c0,0.1-0.1,0.3-0.3,0.3l0,0c-0.5,0.1-0.9,0.5-1,0.9c-0.1,0.2-0.1,0.4-0.2,0.6c-0.2,0.4-0.2,1,0.1,1.4l0,0c0.1,0.1,0.1,0.3,0,0.4  l-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0l0,0c-0.4-0.3-1-0.3-1.4-0.1C8.6,10.9,8.4,11,8.2,11c-0.5,0.2-0.8,0.6-0.9,1l0,0  c0,0.1-0.2,0.3-0.3,0.3H6.5c-0.1,0-0.3-0.1-0.3-0.3c-0.1-0.5-0.5-0.9-0.9-1C5.1,11,4.9,10.9,4.7,10.8z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.3,6.7c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4  c0-1.3-1.1-2.4-2.4-2.4C5.4,4.3,4.3,5.4,4.3,6.7z M5.4,6.7C5.4,6,6,5.4,6.7,5.4v0c0.7,0,1.4,0.6,1.4,1.4c0,0.7-0.6,1.4-1.4,1.4  C6,8.1,5.4,7.5,5.4,6.7z"
                    />
                  </svg>
                }
                selected={selected}
                setSelected={setSelected}
              />
            </Box>
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};
export default Sidebar;
